import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "../../../library/components/Button";
import InputField from "../../../library/components/InputField";
import { Validators } from "../../../library/utilities/Validator";
import captcha from "../../../images/captcha.svg";
import eclipse from "../../../images/eclipse.svg";
import vector from "../../../images/vector.svg";

function SignupForm(signUpObj, setSignUpObj) {
  const location = useLocation();
  const [errorValue, setErrorValue] = useState({});

  const getErrorValue = (key, value) => {
    setErrorValue((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const [obj, setObj] = useState({});
  const handleChange = (key, value) => {
    setObj({ ...obj, [key]: value });
  };
  const clickHandler = () => {
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <div className="box">
        <div className="row p-2">
            <div className="col-sm-12 heading_login">
              <h4>Sign-Up</h4>
              <p>Already have an account? <Link to="/login">Login</Link></p>
            </div>
      </div>
      <div className="row p-2">
          <InputField
            label="Mobile number"
            maxLength="100"
            type="tel"
            name="mobile_number"
            required={true}
            placeholder="Enter mobile number"
            inputClass="col-md-12"
            labelClass="col-md-12"
            value={obj.mobile_number}
            onChange={(val) => handleChange("mobile_number", val)}
            getError={(value) => getErrorValue("mobile_number", value)}
            validators={[
              {
                check: Validators.mobile,
                message: "Please enter valid mobile no.",
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]} 
          />
      </div>
      <div className="row p-2">
      <InputField
            label="Email address (optional)"
            maxLength="100"
            type="tel"
            name="email_address"
            required={true}
            placeholder="Enter email address"
            inputClass="col-md-12"
            labelClass="col-md-12"
            value={obj.email_address}
            onChange={(val) => handleChange("email_address", val)}
            getError={(value) => getErrorValue("email_address", value)}
            validators={[
              {
                check: Validators.email,
                message: "Please enter valid Email Address",
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]} 
          />
      </div>
      {/* <div className="row px-2">
        <div className="col-sm-12 forgot-password-link">
          <Link to="/forgotpassword">Forgot Password?</Link>
        </div>
      </div> */}
      <div className="row px-2 pt-1 pb-4 captcha_wrap">
        <div className="col-sm-6">
          <div className="captcha-image">
            <img id="image" src={captcha} alt={captcha} />
            <img id="eclipse" src={eclipse} alt={eclipse} />
            <img id="vector" src={vector} alt={vector} />
          </div>
          
        </div>

        <div className="col-sm-6">
            <div className="row">
              <InputField
                label="Captcha"
                name="captcha"
                labelClass="col-md-12"
                inputClass="col-md-12 input"
                placeholder="Captcha"
                // spanTitle="Captcha"
                value={signUpObj.captcha}
                type="text"
                required={true}
                onChange={(val) => handleChange("captcha", val)}
                validators={[
                  {
                    check: Validators.required,
                    message: "this field is required",
                  },
                ]}
              />
            </div>
        </div>
      </div>

      <Button
        btnClass="btn-block submit"
        value="Request OTP"
        // value={`${exceedError ? "Sign Up" : "Request OTP"}`}
        onClick={() => {}}
        type="submit"
      />
    </div>

    // <form onSubmit={handleSubmit}>
    //   <div className="box col-md-7 form">
    //     <div className="-mt-2 mb-3">
    //       <b>Signup</b>
    //     </div>
    //     <div>
    //       <div className="row p-2">
    //         <div className="col-md-12">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("mobile", val)}
    //               type="text"
    //               value={obj.mobile}
    //               validators={[
    //                 {
    //                   check: Validators.mobile,
    //                   message: "Please enter valid mobile number",
    //                 },
    //               ]}
    //               placeholder="Mobile Number"
    //               inputClass="col-md-12"
    //               label=""
    //             />
    //           </div>
    //         </div>
    //       </div>
    //       <div className="row p-2">
    //         <div className="col-md-12">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("email", val)}
    //               type="text"
    //               inputClass="col-md-12"
    //               label=""
    //               validators={[
    //                 {
    //                   check: Validators.email,
    //                   message: "Please enter valid email",
    //                 },
    //               ]}
    //               value={obj.email}
    //               placeholder="Email Address (optional)"
    //             />
    //           </div>
    //         </div>
    //       </div>
    //       <div className="row p-2">
    //         <div className="col-md-4">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("captcha", val)}
    //               type="text"
    //               inputClass="col-md-12"
    //               label=""
    //               value={obj.captcha}
    //               placeholder="Captcha"
    //             />
    //           </div>
    //         </div>
    //       </div>
    //       <div className="col-md-12">
    //         <Button
    //           onClick={clickHandler}
    //           btnClass="btn-outline-primary col-md-12"
    //           value="Send OTP"
    //         />
    //       </div>
    //     </div>
    //     <hr />
    //     <div>
    //       <div className="row p-2">
    //         <div className="col-md-6 col-sm-6">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("mobileOtp", val)}
    //               type="text"
    //               inputClass="col-md-12"
    //               label=""
    //               value={obj.mobileOtp}
    //               placeholder="Mobile OTP"
    //             />
    //           </div>
    //         </div>
    //         <div className="col-md-6 col-sm-6">
    //           <Button
    //             onClick={clickHandler}
    //             btnClass="btn-outline-primary col-md-12"
    //             value="Verify OTP"
    //           />
    //         </div>
    //       </div>

    //       <div className="row p-2">
    //         <div className="col-md-6 col-sm-6">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("emailOtp", val)}
    //               type="text"
    //               inputClass="col-md-12"
    //               label=""
    //               value={obj.emailOtp}
    //               placeholder="Email OTP"
    //             />
    //           </div>
    //         </div>
    //         <div className="col-md-6 col-sm-6">
    //           <Button
    //             onClick={clickHandler}
    //             btnClass="btn-outline-primary col-md-12"
    //             value="Verify OTP"
    //           />
    //         </div>
    //       </div>

    //       <div className="row p-2">
    //         <div className="col-md-6 col-sm-6">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("firstName", val)}
    //               type="text"
    //               value={obj.firstName}
    //               inputClass="col-md-12"
    //               label=""
    //               placeholder="First Name"
    //             />
    //           </div>
    //         </div>
    //         <div className="col-md-6 col-sm-6">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("lastName", val)}
    //               type="text"
    //               value={obj.lastName}
    //               inputClass="col-md-12"
    //               label=""
    //               placeholder="Last Name"
    //             />
    //           </div>
    //         </div>
    //       </div>

    //       <div className="row p-2">
    //         <div className="col-md-12">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("password", val)}
    //               type="password"
    //               inputClass="col-md-12"
    //               label=""
    //               value={obj.password}
    //               placeholder="Password"
    //             />
    //           </div>
    //         </div>
    //       </div>
    //       <div className="row p-2">
    //         <div className="col-md-12">
    //           <div className="form-group">
    //             <InputField
    //               disabled={false}
    //               onChange={(val) => handleChange("confirmPassword", val)}
    //               type="password"
    //               inputClass="col-md-12"
    //               label=""
    //               value={obj.confirmPassword}
    //               placeholder="Confirm Password"
    //             />
    //           </div>
    //         </div>
    //       </div>
    //       <div className="col-md-12">
    //         <Button
    //           onClick={clickHandler}
    //           btnClass="btn-primary col-md-12"
    //           value="Submit"
    //         />
    //       </div>
    //     </div>
    //     <hr />
    //     <div className="align text-center">
    //       <p>
    //         Already have an account?
    //         <Button
    //           onClick={handleSubmit}
    //           btnClass="btn-link text"
    //           value="Login"
    //         />
    //       </p>
    //     </div>
    //   </div>
    // </form>
  );
}

export default SignupForm;
